import { Button as MuiButton, Divider, Link, LinkProps, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Row = styled('div')({
  marginBottom: '24px'
})

export const ActionsRow = styled('div')({
  marginTop: 40,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
})

export const InputLabel = styled(Typography)({
  marginBottom: '12px',
  fontWeight: 600
})

export const Button = styled(MuiButton)({
  width: '150px',
  marginLeft: '12px'
})

export const Splitter = styled(Divider)({
  margin: '32px 0'
})

export const StyledLink = styled(Link)<LinkProps>({
  fontWeight: 600,
  cursor: 'pointer'
})
